import React, { memo } from "react";
import associaImmagineENomeANomeUtente from "../interfaccia/funzioniComuni/associaImmagineENomeANomeUtente";

function UltimeModificheUtenteCard({
  nomeUtente,
  utenteCorrente,
  count,
  brands = [],
  isSelected,
  onSelect,
}) {
  const { pathImmagine, nomeDisplay } = associaImmagineENomeANomeUtente(
    nomeUtente,
    utenteCorrente?.username
  );

  const elementiLabel =
    typeof count === "number" ? count : count === 0 ? 0 : "...";
  const maxBrandsToShow = 10;
  const brandList = Array.isArray(brands) ? brands : [];
  const displayedBrands = brandList.slice(0, maxBrandsToShow);
  const extraBrands = Math.max(0, brandList.length - displayedBrands.length);

  const handleClick = () => {
    if (typeof onSelect === "function") {
      onSelect(nomeUtente);
    }
  };

  const cardClasses = [
    "br3",
    "pa3",
    "mb3",
    "flex",
    "items-center",
    "justify-between",
    "pointer",
    isSelected
      ? "bordoColAlt shadow-4"
      : "bordoColScrittaDef-10 hover-bg-light-gray",
    "sfondoBiancoTema",
  ].join(" ");

  return (
    <button
      type="button"
      className="w-100 bg-transparent bn pa0 pointer"
      onClick={handleClick}
    >
      <div className={cardClasses}>
        <div className="flex items-start">
          <div
            className="br-100 overflow-hidden mr3 flex-none flex items-center justify-center bg-light-gray"
            style={{ width: "70px", height: "70px" }}
          >
            {pathImmagine ? (
              <img
                src={pathImmagine}
                alt={nomeDisplay}
                className="w-100 h-100"
                style={{ objectFit: "cover" }}
              />
            ) : (
              <span className="material-icons gray">person</span>
            )}
          </div>
          <div className="tl flex-auto pt2">
            <div className="fw6 pl2">{nomeDisplay ?? nomeUtente}</div>
            <div className="f6 gray pl2">Modifiche: {elementiLabel}</div>
            {displayedBrands.length > 0 && (
              <div className="flex flex-wrap mt3 f6 gray">
                {displayedBrands.map((brand) => (
                  <span key={brand} className="ba br-pill ph2 pv1 mr1 mb1">
                    {brand}
                  </span>
                ))}
                {extraBrands > 0 && (
                  <span className="ba br-pill ph2 pv1 mr1 mb1">
                    +{extraBrands}
                  </span>
                )}
              </div>
            )}
          </div>
        </div>
        {isSelected && (
          <span className="material-icons colScrittaDef-50">chevron_right</span>
        )}
      </div>
    </button>
  );
}

export default memo(UltimeModificheUtenteCard);
